import { FormControl, FormGroup } from '@angular/forms';
import { SendAgain } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Send Again`,
  DATE: $localize`Date`,
  FROM: $localize`From`,
  ROUTE: $localize`Route`,
};
export const REPORT_FILE_NAME = 'Send-Again-Report';

export const PDF_REPORT = {
  NAME: 'Send Again Report',
  HEADER: {
    DRIVER: 'Driver'.toUpperCase() + ':',
  },
  COLUMNS: [
    'Date'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Code'.toUpperCase(),
    'Customer'.toUpperCase(),
    'Street'.toUpperCase(),
    'City'.toUpperCase(),
    'Loop'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'date',
    'trackNo',
    'code',
    'customer',
    'street',
    'city',
    'loop',
  ] as (keyof SendAgain)[],
};

type SendAgainFormField = {
  route: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type SendAgainFormGroup = FormGroup<SendAgainFormField> | null;
